// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"8":"custom-forms","42":"modal","90":"add-to-homescreen","162":"pdp-components","612":"youtube-player","797":"npm.vue-custom-scrollbar"}[chunkId] || chunkId) + "." + {"8":"fd04aca8","42":"6d3ea3c0","90":"de404d09","162":"9918a485","292":"7f680a5f","612":"32511a71","797":"64d4cca4"}[chunkId] + ".js";
};